export const ChatMessageType = Object.freeze({
  endChat: "1",
  message: "2",
  initialDetails: "3",
  startChat: "4"
});